import React from "react";
import { Modal } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { Button, Divider } from "semantic-ui-react";
import LeaveManualTrackForm from "../staff/LeaveList/LeaveManualTrackForm";
import { closeModal } from "../../app/common/modals/modalReducer";

export default function LeaveManualTrackModal(props) {
    const dispatch = useDispatch();
    let profile = props.profile;
    let profileClient = props.profileClient;
    let company = props.company;

    return (
        <Modal size="large" open={true} onClose={() => dispatch(closeModal())} closeOnDimmerClick={false} trigger={<Button>Show Modal</Button>} closeIcon>
            <Modal.Header>&nbsp;</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div className="content_top">
                        <img className="img_header" src="/assets/your_documents.png" alt="Your Documents" />

                        <h2 className="ui center aligned header">Leave Request Form</h2>
                        <p>Submit your dates and documents.</p>
                    </div>

                    <Divider />

                    <LeaveManualTrackForm profile={profile} profileClient={profileClient} company={company} />
                </Modal.Description>
            </Modal.Content>
        </Modal>
    );
}
